export enum Page {
  First,
  Previous,
  Next,
  Last,
  Self
}
